import { boundActionsFactory } from '../../../../../hooks/useBoundActions';
import { setNotAvailablePopupOpenValue } from '../../../../../store/notAvailablePopupOpen';
import { setPhoneCollapse } from '../../../../../store/phone_collapse';

export const useCommercialContactsMainBoundActions = boundActionsFactory({
  setPhoneCollapse,
  setNotAvailablePopupOpenValue,
});
